export const routeRetirementPath = {
  path: '/retirement/:step?',
  name: 'retirement',
  component: () =>
    import(
      /* webpackChunkName: "RetirementPath" */ 'src/pages/RetreatIndicatorsSynthesis/RetreatIndicatorsSynthesis.vue'
    ),
  props: true,
}
